export default __webpack_public_path__ + "static/contractor-cob-ec8140369f1dabd893b9ef2d57942000.png";